module.exports = __webpack_public_path__ + "img/PEDDLR-GIF-200x50.23d69496.gif";